import { useAction, useAppSelector } from '@shared/lib/redux'

import { routerStore } from './router.slice'

export const useRoute = () => {
  return useAppSelector(routerStore.selectors.selectState)
}

export const useSetPrevLocation = () => {
  return useAction((path: string | null) => routerStore.actions.savePrev(path))
}

export const useSetCurrentLocation = () => {
  return useAction((path: string | null) =>
    routerStore.actions.saveCurrent(path)
  )
}

export const useCurrentLocation = () => {
  return useAppSelector(routerStore.selectors.selectCurrentPath)
}
